import React from "react";
import theme from "storybook-styles/theme";
import Layout from "../../components/shared/Layout";
import SEO from "../../components/shared/SeoHelmet";
import HeroSection from "../../components/Toolkits/HeroSection";
import CenteredLightGreenSection from "../../components/Toolkits/CenteredLightGreenSection";
import VideoSection from "../../components/Toolkits/VideoSection";
import ImageAndCopySection from "../../components/Toolkits/ImageAndCopySection";
import QuoteSection from "../../components/Toolkits/QuoteSection";
import BiStackImage from "../../components/Toolkits/images/bi-stack.svg";
import QuoteHeadshot from "../../components/Toolkits/images/headshot.png";
import QuoteLogo from "../../components/Toolkits/images/imperfect-foods-logo.svg";
import QuoteWhiteLogo from "../../components/Toolkits/images/imperfect-foods-logo-white.svg";
import DataLeadersImg from "../../components/Toolkits/images/data-leaders.svg";
import DatasetsImg from "../../components/Toolkits/images/datasets.svg";

const ToolKitTemplate = ({ data }) => {
  return (
    <Layout backgroundColor={theme.colors.green1} fluid>
      <SEO
        title="Tools to Build Modern Business Intelligence Teams"
        ogdescription="The modern BI requires a full reframing of people, processes, and tools—less service desk. Get tools and resources to help you drive more business impact."
        pathname="toolkits/modern-business-intelligence"
      />
      <HeroSection
        title="Modern BI for Data Teams Leading from the Center"
        buttonTxt="Get a Demo"
      />
      <CenteredLightGreenSection
        heading="It’s time to get more from your data"
        bodyCopy="The modern data experience requires a full reframing of people, 
          processes, and tools: less service desk, more influence. This starts with 
          centering your data team to drive driving from the front office—not the back. 
          Own, create, and maintain the central data hub everyone relies upon to make 
          confident, accurate data-driven decisions, regardless of their data analysis 
          skillset. This is the future of business intelligence. Read on to learn how 
          modern data teams can start leading from the center."
      />
      <VideoSection
        heading="Your data. Bigger impact. Powered by Mode."
        videoSrc="https://www.youtube.com/embed/PxR552D7tFA"
      />
      <ImageAndCopySection
        heading="How to Lead from The Center: A Guide for Data Leaders in a New Era
        of BI Transformation"
        bodyCopy="What would it take to turn your data into a true competitive
        advantage? As we embark into the next phase of BI, data leaders are
        asking themselves again, ‘What should the modern data stack do for
        my team today, and how can it drive the business forward for years
        to come?’ Read this paper to take a deep dive into three key
        practice areas for data teams to improve both their influence and
        revenue impact on the business."
        linkText="Get the guide"
        linkDestination="https://mode.com/content/data-teams-leading-from-the-center-with-modern-bi/"
        image={DataLeadersImg}
      />
      <CenteredLightGreenSection
        heading="A singular platform to turn organization knowledge into a competitive advantage"
        bodyImgSrc={BiStackImage}
        bodyImgAlt="Illustration of business intelligence stack"
      />
      <ImageAndCopySection
        heading="End-to-end self-service reporting, your way"
        bodyCopy="Mode’s newest feature is now live in beta: Datasets. Datasets are a reusable and curated foundation for self-service, that makes maintaining and scaling your data, efficient and cost-effective. Datasets creates a layer between your data warehouse and Reports, allowing for more control over governance, centralized logic, and data usage."
        linkText="Learn more"
        linkDestination="https://mode.com/datasets/"
        image={DatasetsImg}
      />
      <QuoteSection
        quoteBody="Now we have a much more collaborative process. We meet with business teams weekly and show them what we’re thinking. We’re not building a dashboard and giving it to them; it's a much more iterative, feedback-based process—you asked us this big question, what do you think about this?"
        quoteAuthor="Adam Smith"
        quoteAuthorTitle="Analytics Manager"
        greenLogo={QuoteLogo}
        whiteLogo={QuoteWhiteLogo}
        quoteAuthorHeadshot={QuoteHeadshot}
      />
    </Layout>
  );
};

export default ToolKitTemplate;
